import { useSelector } from "react-redux";
import USUARIO_PERFIL from "../enums/USUARIO_PERFIL";

function usePerfil() {
  // Recupera o usuário da store
  const xUser = useSelector((store) => store.user);

  // Obtém o perfil do usuário (pode ser string ou objeto)
  const xPerfil = xUser?.perfil;

  const xUsuarioPerfil = xPerfil && USUARIO_PERFIL[xPerfil];
  const xUsuarioPrioridade = xUsuarioPerfil ? xUsuarioPerfil.prioridade : 9;

  // Checa por tipo específico de perfil
  const isAdmin = xPerfil === USUARIO_PERFIL.ad.id;
  const isSuperUser = xPerfil === USUARIO_PERFIL.sp.id;
  const isOperador = xPerfil === USUARIO_PERFIL.op.id;
  const isUserPadrao = xPerfil === USUARIO_PERFIL.us.id;
  const isConsulta = xPerfil === USUARIO_PERFIL.cs.id;

  // Também pode retornar o objeto de perfil correspondente e outros utilitários
  const xPerfilData =
    Object.values(USUARIO_PERFIL).find(
      (xPerfilObj) => xPerfilObj.id === xPerfil
    ) || null;

  return {
    usuario: xUser,
    perfil: xPerfil,
    perfilData: xPerfilData,
    usuarioPerfil: xUsuarioPerfil,
    usuarioPrioridade: xUsuarioPrioridade,
    isAdmin,
    isSuperUser,
    isOperador,
    isUserPadrao,
    isConsulta,
  };
}

export default usePerfil;
